import { trans } from "@mongez/localization";
import { createPortal } from "core/shared";
import { Portal } from "~/modules/shared/components/Portal";
import { RequestWeddingCakesSteps } from "./components";

export const requestWeddingCakesPortal = createPortal(
  "request-wedding-cakes-portal",
);

export function RequestWeddingCakesPortal() {
  return (
    <Portal
      classes={{
        content: "w-[80%]",
      }}
      portal={requestWeddingCakesPortal}
      title={trans("requestWeddingCakes")}
    >
      <div className="flex flex-col gap-11">
        <p className="text-night/75 font-avenir text-sm sm:text-base lg:text-lg 2xl:text-xl">
          {trans("weLoveOccasions")}
        </p>
        <RequestWeddingCakesSteps />
      </div>
    </Portal>
  );
}
